export const MODULE_NAME = 'init';
